// test1867
(1867 && 0);
